import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';
import { Store } from '@ngxs/store';
import { JwtDelete, JwtSet } from '@stores/jwt/jwt.action';
import { JwtStateToken } from '@stores/jwt/jwt.state';
import { JwtServiceInterface, JwtTokens } from '@wizbii/jwt';
import { AuthenticationWebservice } from '@wizbii-utils/angular/webservices';
import { Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

@Injectable()
export class JwtService implements JwtServiceInterface {
  private readonly store = inject(Store);
  private readonly authService = inject(AuthenticationWebservice);

  blacklistRoutes: (string | RegExp)[];

  constructor() {
    this.blacklistRoutes = [
      'https://storage.googleapis.com',
      new RegExp(
        `https://auth.${environment.apiDomain}(?!(/v1/(user|auth)).*(/email|password|overview|login-token|recovery-token|authentication))`,
        'i'
      ),
    ];
  }

  getTokens(): Observable<JwtTokens | undefined> {
    return this.store.selectOnce(JwtStateToken).pipe(map((tokens) => tokens ?? undefined));
  }

  logout(): void {
    this.store.dispatch(new JwtDelete()).pipe(tap(() => window.location.reload()));
  }

  refreshToken(tokens: JwtTokens): Observable<JwtTokens> {
    return this.authService
      .refreshToken(tokens)
      .pipe(switchMap((newTokens) => this.store.dispatch(new JwtSet(newTokens)).pipe(map(() => newTokens))));
  }

  saveLocalTokens(jwtTokens: JwtTokens): void {
    this.store.dispatch(new JwtSet(jwtTokens));
  }
}
